define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "lodash.debounce", "mobx", "../domain", "../services"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, lodash_debounce_1, mobx_2, domain_1, services_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StockSchedule = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class StockSchedule extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockClass", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockClassError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StockTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HeadCount", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "HeadCountError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeek", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeePerHeadPerWeekError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Fee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalFee", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FinalFeeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicableStockNames", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: domain_1.StockNameDomain
            });
            Object.defineProperty(this, "ApplicableStockClasses", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: domain_1.StockClassDomain
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, StockSchedule.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.StockName = b.StockName;
            a.StockClass = (0, EntityUtil_1.toInt)(entity.StockClass);
            a.StockType = b.StockType;
            a.HeadCount = (0, EntityUtil_1.toInt)(entity.HeadCount);
            a.FeePerHeadPerWeek = (0, EntityUtil_1.toFloat)(entity.FeePerHeadPerWeek);
            a.Fee = (0, EntityUtil_1.toFloat)(entity.Fee);
            a.FinalFee = (0, EntityUtil_1.toFloat)(entity.FinalFee);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.updateApplicableStockNames();
            this.updateApplicableStockClasses();
            if (this.Permit) {
                this.onChangeBatchFn = (0, lodash_debounce_1.default)(this.onChange, 250);
                this.addChangeEventAction("StockName", this.onChangeBatchFn.bind(this));
                this.addChangeEventAction("StockClass", this.onChangeBatchFn.bind(this));
                this.addChangeEventAction("HeadCount", this.onChangeBatchFn.bind(this));
                this.addChangeEventAction("FeePerHeadPerWeek", this.onChangeBatchFn.bind(this));
                this.addChangeEventAction("PersistanceState", this.onChangeBatchFn.bind(this));
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, StockSchedule.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            if (!this.IsMarkedForDeletion && this.Permit.IsActive) {
                if (this.Permit.LicenseStatus == domain_1.PermitLicenseStatusDomain.Draft || this.Permit.LicenseStatus == domain_1.PermitLicenseStatusDomain.PendingApproval) {
                    this.validateReqNumber(validationState, "HeadCount", "Head Count");
                    if (this.Permit.IsFeePerHeadPerWeekPropertyRequired) {
                        const min = this.FeePerHeadPerWeekMinValueByStockType;
                        const max = this.FeePerHeadPerWeekMaxValueByStockType;
                        const batchSize = this.FeePerHeadPerWeekBatchSizeByStockType;
                        this.validateReqNumber(validationState, "FeePerHeadPerWeek", `Fee Per ${batchSize > 1 ? `${batchSize} ` : ""}Head Per Week`, { min, max, precision: 2 });
                    }
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                StockName: this.StockName,
                StockClass: this.StockClass,
                StockType: this.StockType,
                HeadCount: this.HeadCount,
                FeePerHeadPerWeek: this.FeePerHeadPerWeek,
                Fee: this.Fee,
                FinalFee: this.FinalFee,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onChange(change) {
            if ((change === null || change === void 0 ? void 0 : change.name) == "StockName") {
                this.updateApplicableStockClasses();
                this.updateStockType();
                if (this.Permit.IsFeePerHeadPerWeekPropertyRequired) {
                    this.Permit.getStockMinMaxValues();
                }
            }
            if (!this.validate().HasErrors) {
                this.Permit.calculateFees();
            }
        }
        static create(p) {
            return new Promise((resolve, reject) => {
                services_1.AppConfigManager.Instance.then(config => {
                    (0, mobx_2.runInAction)(() => {
                        var s = new StockSchedule(null, p);
                        s.HeadCount = 0;
                        s.FeePerHeadPerWeek = 0;
                        s.Fee = 0;
                        s.FinalFee = 0;
                        s.StockName = domain_1.StockNameDomain.Values[0].key;
                        p.StockSchedule.push(s);
                        resolve(s);
                    });
                });
            });
        }
        get ParentHeadCount() {
            if (this.Permit.ParentPermit != null) {
                for (let s of this.Permit.ParentPermit.StockSchedule) {
                    if (s.StockName == this.StockName && s.StockClass == this.StockClass) {
                        return s.HeadCount;
                    }
                }
                return 0;
            }
            else {
                return -1;
            }
        }
        updateApplicableStockNames() {
            let applicable = new domain_1.DynamicDomain();
            domain_1.StockNameDomain.Values.filter(x => {
                return x.key != domain_1.StockNameDomain.Asses && x.key != domain_1.StockNameDomain.Vicunas;
            }).forEach(x => {
                applicable.addByKv(x.key, x.value);
            });
            this.ApplicableStockNames = applicable;
            console.info("ApplicableStockNames", applicable === null || applicable === void 0 ? void 0 : applicable.Values);
        }
        updateApplicableStockClasses() {
            let applicable = new domain_1.DynamicDomain();
            let isSelectedStockClassApplicable = false;
            for (let stockRule of services_1.AppConfigManager.InstanceSync.PermitStockRefData) {
                if (stockRule.StockName == this.StockName) {
                    let kv = domain_1.StockClassDomain.findByKey(stockRule.StockClass);
                    if (kv != null) {
                        applicable.add(kv);
                        if (kv.key == this.StockClass) {
                            isSelectedStockClassApplicable = true;
                        }
                    }
                }
            }
            if (!isSelectedStockClassApplicable && applicable.length > 0) {
                this.StockClass = applicable.Values[0].key;
            }
            this.ApplicableStockClasses = applicable;
            console.info("ApplicableStockClasses", applicable === null || applicable === void 0 ? void 0 : applicable.Values);
        }
        updateStockType() {
            this.StockType = services_1.AppConfigManager.InstanceSync.getPermitStockType(this.StockName, this.StockClass);
        }
        clampFeePerHeadPerWeek() {
            if (this.Permit.IsFeePerHeadPerWeekPropertyRequired) {
                if (this.FeePerHeadPerWeek < this.FeePerHeadPerWeekMinValueByStockType) {
                    console.info("updateStockScheduleFeePerHeadPerWeek", this.FeePerHeadPerWeek, "to", this.FeePerHeadPerWeekMinValueByStockType);
                    this.FeePerHeadPerWeek = this.FeePerHeadPerWeekMinValueByStockType;
                }
                if (this.FeePerHeadPerWeek > this.FeePerHeadPerWeekMaxValueByStockType) {
                    console.info("updateStockScheduleFeePerHeadPerWeek", this.FeePerHeadPerWeek, "to", this.FeePerHeadPerWeekMaxValueByStockType);
                    this.FeePerHeadPerWeek = this.FeePerHeadPerWeekMaxValueByStockType;
                }
            }
        }
        get FeePerHeadPerWeekMinValueByStockType() {
            if (this.StockType == domain_1.StockTypeDomain.Large) {
                return this.Permit.FeePerHeadPerWeekForLargeStockMinValue;
            }
            else if (this.StockType == domain_1.StockTypeDomain.Small) {
                return this.Permit.FeePerHeadPerWeekForSmallStockMinValue;
            }
        }
        get FeePerHeadPerWeekMaxValueByStockType() {
            if (this.StockType == domain_1.StockTypeDomain.Large) {
                return this.Permit.FeePerHeadPerWeekForLargeStockMaxValue;
            }
            else if (this.StockType == domain_1.StockTypeDomain.Small) {
                return this.Permit.FeePerHeadPerWeekForSmallStockMaxValue;
            }
        }
        get FeePerHeadPerWeekBatchSizeByStockType() {
            if (this.StockType == domain_1.StockTypeDomain.Large) {
                return this.Permit.FeePerHeadPerWeekForLargeStockBatchSize;
            }
            else if (this.StockType == domain_1.StockTypeDomain.Small) {
                return this.Permit.FeePerHeadPerWeekForSmallStockBatchSize;
            }
        }
    }
    exports.StockSchedule = StockSchedule;
    Object.defineProperty(StockSchedule, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "StockSchedule"
    });
    Object.defineProperty(StockSchedule, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Stock Schedule"
    });
    Object.defineProperty(StockSchedule, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "StockName", "StockClass", "StockType", "HeadCount", "FeePerHeadPerWeek", "Fee", "FinalFee"]
    });
    Object.defineProperty(StockSchedule, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "StockNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(StockSchedule, "StockNameDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(StockSchedule, "StockNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "StockClassDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(StockSchedule, "StockClassReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "StockTypeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(StockSchedule, "StockTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(StockSchedule, "StockTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "HeadCountReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "FeePerHeadPerWeekReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "FeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(StockSchedule, "FinalFeeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "StockName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "StockNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "StockClass", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "StockClassError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "StockType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "StockTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "HeadCount", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "HeadCountError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "FeePerHeadPerWeek", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "FeePerHeadPerWeekError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "Fee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "FeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "FinalFee", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "FinalFeeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], StockSchedule.prototype, "ParentHeadCount", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "ApplicableStockNames", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], StockSchedule.prototype, "ApplicableStockClasses", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "updateApplicableStockNames", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "updateApplicableStockClasses", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "updateStockType", null);
    tslib_1.__decorate([
        mobx_1.action
    ], StockSchedule.prototype, "clampFeePerHeadPerWeek", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], StockSchedule.prototype, "FeePerHeadPerWeekMinValueByStockType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], StockSchedule.prototype, "FeePerHeadPerWeekMaxValueByStockType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], StockSchedule.prototype, "FeePerHeadPerWeekBatchSizeByStockType", null);
});
